(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ReduxTs", [], factory);
	else if(typeof exports === 'object')
		exports["ReduxTs"] = factory();
	else
		root["ReduxTs"] = factory();
})(this, function() {
return 